<template>
  <iframe ref="emr" seamless :src="url" width="98%" height="98%" style="border: none; margin-top: 5px"></iframe>
</template>
<script>
  import { mapGetters } from "sw-hic";

  export default {
    props: {
      entity: Object,
    },
    data() {
      return {
        url: null,
      };
    },
    computed: {
      ...mapGetters(["token", "setting", "user"]),
      readonly() {
        return this.entity?.state == "已离院" || this.entity?.state == "已结算";
      },
    },
    watch: {
      entity() {
        this.refresh();
      },
    },
    mounted() {
      this.refresh();
    },
    methods: {
      refresh() {
        this.url = `${this.setting.emrServer}/#/studio?ip=${this.entity.ipNo}&dept=${this.user.deptCode}&readonly=${this.readonly}&mrCategory=HuShi&token=${this.token}`;
        console.log("emrUrl", this.url);
        this.$refs.emr.contentWindow.postMessage({ event: "refresh", data: this.entity.ipNo }, "*");
      },
    },
  };
</script>
